import type { Filter, FilterDataSwitch } from '@/app/common/filters/core/filtersTypes.ts';
import { FilterSwitchPill } from '@/app/common/filters/types/switch/FilterSwitchPill.ts';
import type { FilterTypeBehaviour } from '@/app/common/filters/types/filterTypeDefinition.ts';

const dataOf = (filter: Filter) => filter.data as FilterDataSwitch;

export const switchType: FilterTypeBehaviour = {
  pillLabels: FilterSwitchPill,
  serialise: (filter) => (dataOf(filter).selected ? '1' : undefined),
  isSelected: (filter) => dataOf(filter).selected,
  resetValue: (filter) => ({ ...filter, data: { ...dataOf(filter), selected: false } }),
  selectedOptions: (filter) =>
    dataOf(filter).selected ? [{ label: dataOf(filter).label, value: filter.name, selected: true }] : [],
  chips: {
    options: (filter) => [
      { label: dataOf(filter).label, value: filter.name, selected: dataOf(filter).selected, disabled: filter.disabled },
    ],
    toggle: (filter) => ({ ...filter, data: { ...dataOf(filter), selected: !dataOf(filter).selected } }),
  },
};
